import PropTypes from 'prop-types';
import { twMerge } from 'tailwind-merge';

import Box from 'shopper/components/Box';
import Spinner from 'shopper/components/Spinner';

const LoadingBox = ({ className }) => (
  <Box
    className={twMerge('h-[600px] items-center justify-center', className)}
    full
  >
    <Spinner />
  </Box>
);

LoadingBox.propTypes = {
  className: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
};

export default LoadingBox;
